import { VisitorVariations } from '@src/container/handleIframeMessage/types';
import {
  BucketingDTO,
  FsEventReducerAction,
  FsReducerAction,
  FsVariationToForce,
  FsVariationToForceReducerAction,
  VisitorVariationUpdateParam,
} from '../type';

export function setBucketingFile(bucketingFile: BucketingDTO): FsReducerAction {
  return { type: 'setBucketingFile', bucketingFile };
}

export function updateVisitorVariations(value: Record<string, VisitorVariations>): FsReducerAction {
  return { type: 'updateVisitorVariations', value };
}

export function updateVisitorExposedVariations(
  value: Record<string, VisitorVariations>,
  param: VisitorVariationUpdateParam
): FsReducerAction {
  return { type: 'updateVisitorExposedVariations', value, param };
}

export function searchFsCampaigns(value: string): FsReducerAction {
  return { type: 'searchFsCampaigns', value };
}

export function addFsHit(value: Record<string, unknown>[]): FsEventReducerAction {
  return { type: 'add', value };
}

export function clearFsHit(): FsEventReducerAction {
  return { type: 'clearHits' };
}

export function addVariationToForce(value: Record<string, FsVariationToForce>): FsVariationToForceReducerAction {
  return { type: 'addVariationToForce', value };
}

export function addVariationToForceTemp(value: Record<string, FsVariationToForce>): FsVariationToForceReducerAction {
  return { type: 'addVariationToForceTemp', value };
}

export function clearVariationsToForce(): FsVariationToForceReducerAction {
  return { type: 'clearVariationsToForce' };
}
